/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2023. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createReducer, on } from '@ngrx/store';

import { ApiManagementConfigDTO } from '@settings/api-management/shared';
import { ApiManagementActions } from '../actions';

export const API_MANAGEMENT_FEATURE_KEY = 'api-management';

export interface ApiManagementState {
  configs: ApiManagementConfigDTO[] | null;
  loading: boolean;
  updating: boolean;
  errorMessage: string | null;
}

const initialState: ApiManagementState = {
  configs: null,
  loading: false,
  updating: false,
  errorMessage: null,
};

export const apiManagementReducer = createReducer(
  initialState,

  on(ApiManagementActions.loadApiConfgis, ApiManagementActions.deleteConfig, (state) => ({
    ...state,
    loading: true,
  })),

  on(ApiManagementActions.createConfig, ApiManagementActions.updateConfig, (state) => ({
    ...state,
    updating: true,
  })),

  on(ApiManagementActions.loadApiConfgisSuccess, (state, { configs }) => ({
    ...state,
    configs,
    loading: false,
  })),

  on(ApiManagementActions.createConfigSuccess, (state, { config }) => ({
    ...state,
    configs: [config, ...(state.configs || [])],
    updating: false,
  })),

  on(ApiManagementActions.updateConfigSuccess, (state, { config }) => ({
    ...state,
    configs: (state.configs || []).map((c) => (c.id === config.id ? config : c)),
    updating: false,
  })),

  on(ApiManagementActions.deleteConfigSuccess, (state, { id }) => ({
    ...state,
    configs: (state.configs || []).filter((c) => c.id !== id),
    loading: false,
  })),

  on(ApiManagementActions.failure, (state, { errorMessage }) => ({
    ...state,
    loading: false,
    updating: false,
    errorMessage,
  }))
);
